<template>
  <div class="section-wrapper">
    <LogoLink class="logo-link" />

    <section class="section">
      <div class="content">
        <TitleComponent
          title="Król nie włada nad Internet Explorer!"
          subtitle="Spróbuj na innej przeglądarce."
        />

        <!-- mobile img -->
        <img
          class="img img--mobile"
          src="/images/sections-mobile/404.png"
          alt=""
        />
        <!-- e/o mobile img -->
      </div>

      <!-- desktop img -->
      <img
        class="img img--desktop"
        src="/images/sections/404.svg"
        alt=""
        height="100%"
        width="100%"
      />
      <!-- e/o desktop img -->
    </section>
  </div>
</template>

<script>
import TitleComponent from '@/components/common/Title'

export default {
  components: {
    TitleComponent
  }
}
</script>

<style lang="scss" scoped>
.section-wrapper {
  width: 100vw;
  max-width: 100vw;
  height: 100vh;

  background: $background-color;

  position: relative;
  overflow: hidden;
}

.section {
  @include fill-space;
  @include center-content;
  padding: 12vw 8vw 5vw 15vw;
}

.logo-link {
  position: absolute;
  top: 50px;
  left: 50px;
  width: 100%;
  pointer-events: none;
}

.img {
  &--desktop {
    @include hide-down(lg);
  }

  &--mobile {
    @include hide-up(lg);
    max-width: 300px;
    margin-top: 50px;
  }
}

.text {
  text-transform: uppercase;
  margin-top: 50px;
}

.link {
  @include reset-link;
  text-decoration: underline;
}
</style>
